




































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { CrudDialogMode, Article, ArticleTag, TargetAudience } from '@/utils/types'
import { uploadImage, translate } from '../utils/helpers'

@Component
export default class ArticleCrud extends Vue {
  @Prop(String) title!: string;
  @Prop(Object) article?: Article;
  @Prop(Number) mode!: CrudDialogMode;
  CrudDialogMode = CrudDialogMode;
  isLoading = false
  imageForUpload: File | null = null
  data: Article = this.articlePropData;

  @Watch('article')
  onArticlePropChange () {
    this.data = this.articlePropData
    this.imageForUpload = null
  }

  get articlePropData () {
    return {
      id: this.article?.id ?? '',
      title: this.article?.title ?? '',
      subtitle: this.article?.subtitle ?? '',
      text: this.article?.text ?? '',
      image: this.article?.image ?? '',
      tags: this.article?.tags ?? [],
      targetAudience: this.article?.targetAudience ?? TargetAudience.EVERYONE
    }
  }

  get selectableTags () {
    return Object.values(ArticleTag).map(tag => ({ text: translate(tag), value: tag }))
  }

  get isFormVisible () {
    return (
      this.mode === CrudDialogMode.CREATE || this.mode === CrudDialogMode.EDIT
    )
  }

  get isSubmitButtonDisabled () {
    return !this.data.title || !this.data.subtitle || !this.data.text || !this.data.tags?.length
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    if (this.isSubmitButtonDisabled) {
      return
    }
    if (this.imageForUpload) {
      this.isLoading = true
      this.data.image = await uploadImage(this.imageForUpload)
      this.isLoading = false
    }
    this.$emit('submit', this.data)
  }

  handleImageSelected (event: Event) {
    const target = event.target as HTMLInputElement
    this.imageForUpload = target.files?.item(0) || null
  }
}
